export enum PurchaseProductType {
	ParentProduct = 1,
	Bundle,
	Subscription,
	ContentBundle,
}
